import { StyledTasksDrawer } from './TasksDrawer.styled';
import { getDrawerSize } from './utils';

export default function TasksDrawer({ state, children, ...props }) {
  const drawerSize = getDrawerSize(
    state.changeStudents,
    state.changeActivities
  );

  return (
    <StyledTasksDrawer width={drawerSize} loading={state.loading} {...props}>
      {children}
    </StyledTasksDrawer>
  );
}
